import { REQUEST, SUCCESS, FAILURE, CLEAR } from '../../actions/models/delete';

const initialState = {
  isLoading: false,
  response: null,
  error: null
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null
      };
    case SUCCESS:
      return {
        ...state,
        isLoading: false,
        response: action.payload,
        error: null
      };
    case FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case CLEAR:
      return initialState;
    default:
      return state;
  }
} 